import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { getExtensionPath } from '@wix/cli-astro-definitions';
import {
  BackOfficeHostingPlatforms,
  ComponentType,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';

// NOTE: path is relative to the build folder
const DASHBOARD_MODAL_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-modal'
);

export async function generateDashboardModal(
  projectFolder: string,
  route: string,
  title: string
) {
  const component: Component = {
    compId: randomUUID(),
    compType: ComponentType.BACK_OFFICE_MODAL,
    compName: title,
    compData: {
      backOfficeModal: {
        hostingPlatform: BackOfficeHostingPlatforms.BUSINESS_MANAGER,
        title,
        width: 550,
        height: 600,
      },
    },
  };

  const cwd = getExtensionPath(projectFolder, route);
  const modalConfigJSON = toJsonString(component, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_MODAL_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      modalId: component.compId,
      route,
      title,
      modalConfigJSON,
    },
  });
}
